const cachedBanks = {};
const cachedIntegrationBanks = {};

class BankService {
  static init(banks) {
    banks.forEach(bank => {
      const key = bank.name
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .split(' ')
        .join('_')
        .toUpperCase();

      // if is a transfeera integrated bank account (accept_payment)
      if (Array.isArray(bank.BankAccounts) && bank.BankAccounts.length === 1) {
        cachedIntegrationBanks[key] = {
          id: bank.id,
          name: bank.name,
          code: bank.code,
          bank_account_id: bank.BankAccounts[0].id
        };
      }

      cachedBanks[key] = {
        id: bank.id,
        name: bank.name,
        code: bank.code
      };
    });
  }

  static get() {
    return cachedBanks;
  }

  static getAcceptPayments() {
    return cachedIntegrationBanks;
  }
}

module.exports = BankService;
